<template>
  <div>
    <!-- <b-button variant="warning" href="https://test.shepa.com/api/uploadedData" target="_blank">بروزرسانی داده ها</b-button> -->
    <list-table
      url="wallerpaymentrequested"
      title="درخواست های پرداخت درگاه های بین المللی"
      detailUrl="paynationalprq"
      :fields="fields"
      :params="params"
    ></list-table>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";

export default {
  name: "WalletPaymentRequest",
  components: {
    "list-table": TableShowData,
  },
  data() {
    return {
      fields: [
        {
          key: "website_name",
          label: "وبسایت",
        },
        {
          key: "website",
          label: "آدرس وبسایت",
        },
        {
          key: "bes",
          label: "مبلغ ارز",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "nickname",
          label: "نام صاحب حساب",
        },
        {
          key: "shaba_number",
          label: "شماره شبا",
        },
        {
          key: "gateway_type",
          label: "نوع درگاه",
        },
        {
          key: "status",
          label: "وضعیت",
          formatter(value, key, item) {
            return item.tracking_number ? "انجام شده" : "انجام نشده";
          },
        },
        {
          key: "rial_price",
          label: "مبلغ در زمان تسویه",
          formatter(value, key, item) {
            if (value) {
              return Number(value / item.bes).toLocaleString()
            }
            else{
              return 0;
            }
          },
        },
        {
          key: "tracking_number",
          label: "کد رهگیری پرداخت",
        },
        {
          key: "settle_date",
          label: "تاریخ واریزی",
          formatter(value, key, item) {
            return value!==null ? persianDate.getDateByFormat(value) : '-';
          },
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
      params: [
        {
          label: "تاریخ ایجاد از",
          field: "rdatefrom",
          type: "date-picker",
        },
        {
          label: "تاریخ ایجاد تا",
          field: "rdateto",
          type: "date-picker",
        },
        {
          label: "تاریخ واریز از",
          field: "sdatefrom",
          type: "date-picker",
        },
        {
          label: "تاریخ واریز تا",
          field: "sdateto",
          type: "date-picker",
        },
        {
          label: "اسم وبسایت",
          field: "website_name",
          type: "text",
        },
        {
          label: "آدرس وبسایت",
          field: "website",
          type: "text",
        },
        {
          label: "مبلغ",
          field: "amount",
          type: "text",
        },
        {
          label: "کد رهگیری",
          field: "tracking_number",
          type: "text",
        },
      ],
    };
  },
  methods: {
    // refreshList(){
    //   httpHelper.getData('uploadedData').then(res=>{
    //   })
    // }
  },
};
</script>